<template>
  <v-container fluid>
    <HeaderPrint :rev="rev" />
    <div v-for="(cause, index) in rootCauses" :key="cause.id">
      <RootCausePrint
        class="mb-1"
        style="min-height: 400px;"
        :rootCause="cause"
      />
      <v-divider
        v-if="index === 0 && rootCauses.length === 2"
        class="theme--print"
      />
    </div>
  </v-container>
</template>

<script>
import HeaderPrint from './HeaderPrint.vue'
import RootCausePrint from './RootCausePrint.vue'

export default {
  name: 'RootCausesPagePrint',

  components: {
    HeaderPrint,
    RootCausePrint,
  },

  props: {
    rootCauses: {
      type: Array,
      required: true,
    },
    rev: {
      type: Object,
      required: true,
    },
  },
}
</script>
